import { DataAccess } from "../dataaccess/data.access";

export type NewsArticleVisibility = "PUBLIC" | "LOGGED_IN" | "ORG_MEMBERS" | "PRIVATE";

export type NewsListView = "active" | "archived";

export interface NewsArticleRole {
    newsArticleId?: string;
    contRoleId?: number;
}

export interface NewsArticle {
    newsArticleId?: string;
    acctId?: number;
    acctName?: string;
    title?: string;
    description?: string;
    imageUrl?: string;
    authorContId?: number;
    createDt?: string;
    visibility?: NewsArticleVisibility;
    promotedToHome?: boolean;
    lastModUser?: string;
    lastModDt?: string;
    publishStartDt?: string;
    publishEndDt?: string;
    roleIds?: NewsArticleRole[];
}

export type NewsArticleRequest = {
    article: NewsArticle;
    allowedRoleIds?: number[];
};

const SERVICE = "NewsArticleService";

export class NewsArticleService {
    public static getNewsArticles(acctId: number, options?: { view?: NewsListView }) {
        const url = `/organization/${acctId}/news.json?${DataAccess.params({
            view: options?.view,
        })}`;
        return DataAccess.get<NewsArticle[]>(DataAccess.injectCaller(url, `${SERVICE}.getNewsArticles`));
    }

    public static getNewsArticle(acctId: number, newsArticleId: string) {
        const url = `/organization/${acctId}/news/${newsArticleId}.json`;
        return DataAccess.get<NewsArticle>(DataAccess.injectCaller(url, `${SERVICE}.getNewsArticle`));
    }

    public static createNewsArticle(acctId: number, request: NewsArticleRequest) {
        const url = `/organization/${acctId}/news.json`;
        return DataAccess.post<NewsArticle>(DataAccess.injectCaller(url, `${SERVICE}.createNewsArticle`), {
            NewsArticleRequest: request,
        });
    }

    public static updateNewsArticle(acctId: number, newsArticleId: string, request: NewsArticleRequest) {
        const url = `/organization/${acctId}/news/${newsArticleId}.json`;
        return DataAccess.put<NewsArticle>(DataAccess.injectCaller(url, `${SERVICE}.updateNewsArticle`), {
            NewsArticleRequest: request,
        });
    }

    public static deleteNewsArticle(acctId: number, newsArticleId: string) {
        const url = `/organization/${acctId}/news/${newsArticleId}.json`;
        return DataAccess.delete(DataAccess.injectCaller(url, `${SERVICE}.deleteNewsArticle`));
    }

    public static getMyNews(limit: number = 10): Promise<NewsArticle[]> {
        const url = `/engagement/my/news.json?${DataAccess.params({ limit })}`;
        return DataAccess.get<NewsArticle[]>(DataAccess.injectCaller(url, `${SERVICE}.getMyNews`));
    }

    public static requestPromoteToHome(acctId: number, newsArticleId: string, reason: string) {
        const url = `/organization/${acctId}/news/${newsArticleId}/request-promote-to-home.json`;
        return DataAccess.post(DataAccess.injectCaller(url, `${SERVICE}.requestPromoteToHome`), { reason });
    }
}
